// extracted by mini-css-extract-plugin
module.exports = {"filmCardRowMobile":"filmcardMobile_filmCardRowMobile__N3bTp","imageWrapper":"filmcardMobile_imageWrapper__2L7S6","textWrapper":"filmcardMobile_textWrapper__2d-5B"};